// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

export interface SymbolConfig {
  color?: string; // Hex string preferred
  size?: number; // for points
  width?: number; // for lines
  angle?: number; // angle to rotate the symbol
  outlineColor?: string;
  outlineWidth?: number;
  Fill?: string | 'none';
  style?: string;
}

export interface LayerStyleConfig {
  geometryType: 'point' | 'polyline' | 'polygon';
  symbol: SymbolConfig;
  RendererType?: 'SimpleMarker' | 'Simple';
}

export interface StyleConfig {
  defaults: {
    point: LayerStyleConfig;
    polyline: LayerStyleConfig;
    polygon: LayerStyleConfig;
  };
  layers: Record<string, LayerStyleConfig>;
}

export const styleConfig: StyleConfig = {
  // default style configuration
  defaults: {
    point: {
      geometryType: 'point',
      symbol: {
        color: '#0078D4',
        size: 8,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    polyline: {
      geometryType: 'polyline',
      symbol: {
        color: '#0078D4',
        width: 2,
      },
      RendererType: 'Simple',
    },
    polygon: {
      geometryType: 'polygon',
      symbol: {
        color: '#0078D4',
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
  },
  // Style configuration for specific layers.
  // Style configuration for new layers can be added here
  layers: {
    D_UP_BOTTOM: {
      geometryType: 'point',
      symbol: {
        color: '#00BDBD',
        Fill: 'none',
        style: 'Centered Circle',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    D_UP_TOP: {
      geometryType: 'point',
      symbol: {
        color: '#FFAAAA',
        Fill: 'none',
        style: 'Centered Circle',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    R_RR_CROSSGUARD: {
      geometryType: 'point',
      symbol: {
        color: '#FF0000',
        Fill: 'none',
        style: 'Centered Hexagon',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    R_RR_MILE_POST: {
      geometryType: 'point',
      symbol: {
        color: '#00FFFF',
        Fill: 'none',
        style: 'Centered Hexagon',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    S_BOLLARD: {
      geometryType: 'point',
      symbol: {
        color: '#FFAABF',
        Fill: 'none',
        style: 'Centered Hexagon',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    S_SIGN: {
      geometryType: 'point',
      symbol: {
        color: '#FF00BF',
        Fill: 'none',
        style: 'Centered Star',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    S_TOWER: {
      geometryType: 'point',
      symbol: {
        color: '#BD00BD',
        Fill: 'none',
        style: 'Centered Square',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    T_GROUND_CLEARANCE: {
      geometryType: 'point',
      symbol: {
        color: '#000000',
        Fill: 'none',
        style: 'Standing Circle',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    T_LOWEST_LINE_SAG: {
      geometryType: 'point',
      symbol: {
        color: '#000000',
        Fill: 'none',
        style: 'Standing Circle',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    T_ANTENNA_TOP: {
      geometryType: 'point',
      symbol: {
        color: '#FF73DF',
        Fill: 'none',
        style: 'Centered Circle',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    T_COMM_BOX: {
      geometryType: 'point',
      symbol: {
        color: '#B2B2B2',
        Fill: 'none',
        style: 'Centered Square',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    T_COMM_POA: {
      geometryType: 'point',
      symbol: {
        color: '#FF5500',
        Fill: 'none',
        style: 'Centered Circle',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    T_CROSSARM: {
      geometryType: 'point',
      symbol: {
        color: '#FF00FF',
        Fill: 'none',
        style: 'Centered Circle',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    T_GUY_ANCHOR: {
      geometryType: 'point',
      symbol: {
        color: '#55FF00',
        Fill: 'none',
        style: 'Centered Circle',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    T_GUY_POA: {
      geometryType: 'point',
      symbol: {
        color: '#55FF00',
        Fill: 'none',
        style: 'Centered Circle',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    T_LP_BOTTOM: {
      geometryType: 'point',
      symbol: {
        color: '#E6E600',
        Fill: 'none',
        style: 'Centered Circle',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    T_POWER_POA: {
      geometryType: 'point',
      symbol: {
        color: '#0070FF',
        Fill: 'none',
        style: 'Centered Circle',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    T_RISER: {
      geometryType: 'point',
      symbol: {
        color: '#C500FF',
        Fill: 'none',
        style: 'Centered Diamond Wide',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    T_SIGNAL_BOTTOM: {
      geometryType: 'point',
      symbol: {
        color: '#00C5FF',
        Fill: 'none',
        style: 'Centered Circle',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    T_STREETLIGHT_BOTTOM: {
      geometryType: 'point',
      symbol: {
        color: '#E6E600',
        Fill: 'none',
        style: 'Centered Triangle',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    T_STREETLIGHT_DRIP: {
      geometryType: 'point',
      symbol: {
        color: '#E6E600',
        Fill: 'none',
        style: 'Centered Diamond',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    T_STREETLIGHT_TOP: {
      geometryType: 'point',
      symbol: {
        color: '#E6E600',
        Fill: 'none',
        style: 'Centered Triangle',
        size: 10,
        angle: 180,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    T_TOWER_BOTTOM: {
      geometryType: 'point',
      symbol: {
        color: '#00FFFF',
        Fill: 'none',
        style: 'Centered Circle',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    T_TRANSFORMER: {
      geometryType: 'point',
      symbol: {
        color: '#00FFC5',
        Fill: 'none',
        style: 'Centered Rounded Square',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    T_TRANSFORMER_DRIP: {
      geometryType: 'point',
      symbol: {
        color: '#00FFC5',
        Fill: 'none',
        style: 'Centered Diamond',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    T_UP_BOTTOM: {
      geometryType: 'point',
      symbol: {
        color: '#000000',
        Fill: 'none',
        style: 'Telecom',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    T_UP_TOP: {
      geometryType: 'point',
      symbol: {
        color: '#FFFF00',
        Fill: 'none',
        style: 'Centered Circle',
        size: 6,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    T_WEATHER_HD: {
      geometryType: 'point',
      symbol: {
        color: '#C500FF',
        Fill: 'none',
        style: 'Centered Octagon',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    U_CATCHBASIN: {
      geometryType: 'point',
      symbol: {
        color: '#00FF00',
        Fill: 'none',
        style: 'Centered Square',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    U_CULVERT: {
      geometryType: 'point',
      symbol: {
        color: '#008DBD',
        Fill: 'none',
        style: 'Centered Square',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    U_GAS_METER: {
      geometryType: 'point',
      symbol: {
        color: '#7EBDAD',
        Fill: 'none',
        style: 'Centered Circle',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    U_HANDHOLE: {
      geometryType: 'point',
      symbol: {
        color: '#7E8DBD',
        Fill: 'none',
        style: 'Centered Square',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    U_HYDRANT: {
      geometryType: 'point',
      symbol: {
        color: '#FF0000',
        Fill: 'none',
        style: 'Centered Triangle',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    U_LANDMARK: {
      geometryType: 'point',
      symbol: {
        color: '#815681',
        Fill: 'none',
        style: 'Centered Hexagon',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    U_MANHOLE: {
      geometryType: 'point',
      symbol: {
        color: '#0000FF',
        Fill: 'none',
        style: 'Centered Circle',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    U_MARKER: {
      geometryType: 'point',
      symbol: {
        color: '#00FF7F',
        Fill: 'none',
        style: 'Centered Circle',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    U_MILE_MARKER: {
      geometryType: 'point',
      symbol: {
        color: '#600081',
        Fill: 'none',
        style: 'Centered Circle',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    U_PEDESTAL: {
      geometryType: 'point',
      symbol: {
        color: '#FFEAAA',
        Fill: 'none',
        style: 'Centered Hexagon',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    U_POLE_LIGHT: {
      geometryType: 'point',
      symbol: {
        color: '#FF3F00',
        Fill: 'none',
        style: 'Centered Circle',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    U_POLE_SIGNAL: {
      geometryType: 'point',
      symbol: {
        color: '#FF0000',
        Fill: 'none',
        style: 'Centered Triangle',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    U_POLE_UTILITY: {
      geometryType: 'point',
      symbol: {
        color: '#810000',
        Fill: 'none',
        style: 'Centered Circle',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    U_TELCO_TOWER: {
      geometryType: 'point',
      symbol: {
        color: '#FF003F',
        Fill: 'none',
        style: 'Centered Circle',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    U_TRANSMISSION_POLE: {
      geometryType: 'point',
      symbol: {
        color: '#FF003F',
        Fill: 'none',
        style: 'Centered Circle',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    U_VALVE: {
      geometryType: 'point',
      symbol: {
        color: '#FF7F00',
        Fill: 'none',
        style: 'Centered Circle',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    U_VAULT: {
      geometryType: 'point',
      symbol: {
        color: '#005EBD',
        Fill: 'none',
        style: 'Centered Square',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    V_BUSH: {
      geometryType: 'point',
      symbol: {
        color: '#6834',
        Fill: 'none',
        style: 'Park',
        size: 6,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    V_SPark: {
      geometryType: 'point',
      symbol: {
        color: '#00BD00',
        Fill: 'none',
        style: 'Park',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    A_OBSTRUCTION: {
      geometryType: 'polygon',
      symbol: {
        color: '#FF0000',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#FF0000',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    A_PARCEL: {
      geometryType: 'polygon',
      symbol: {
        color: '#FFFFFF',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#FFFFFF',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    A_ROAD_SHOULDER: {
      geometryType: 'polygon',
      symbol: {
        color: '#FFFFFF',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#FFFFFF',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    A_ROW: {
      geometryType: 'polygon',
      symbol: {
        color: '#FFFFFF',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#FFFFFF',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    B_OVERHANG: {
      geometryType: 'polygon',
      symbol: {
        color: '#00FF00',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#00FF00',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    B_OVERHANG_A: {
      geometryType: 'polygon',
      symbol: {
        color: '#00FF00',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#00FF00',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    B_OVERHANG_OTHER: {
      geometryType: 'polygon',
      symbol: {
        color: '#FF0000',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#FF0000',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    C_CONC_PAD: {
      geometryType: 'polygon',
      symbol: {
        color: '#FFFFAA',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#FFFFAA',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    R_ADA: {
      geometryType: 'polygon',
      symbol: {
        color: '#FF007F',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#FF007F',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    R_BRIDGE: {
      geometryType: 'polygon',
      symbol: {
        color: '#BD0000',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#BD0000',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    R_CURB: {
      geometryType: 'polygon',
      symbol: {
        color: '#FF00FF',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#FF00FF',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    R_CURB_BERM: {
      geometryType: 'polygon',
      symbol: {
        color: '#680068',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#680068',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    R_DRIVEWAY_ASPH: {
      geometryType: 'polygon',
      symbol: {
        color: '#BFAAFF',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#BFAAFF',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    R_DRIVEWAY_CONC: {
      geometryType: 'polygon',
      symbol: {
        color: '#BF00FF',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#BF00FF',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    R_DRIVEWAY_PAVER: {
      geometryType: 'polygon',
      symbol: {
        color: '#566081',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#566081',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    R_DRIVEWAY_UNPAVED: {
      geometryType: 'polygon',
      symbol: {
        color: '#AAFFAA',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#AAFFAA',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    R_GUTTER: {
      geometryType: 'polygon',
      symbol: {
        color: '#00FFFF',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#00FFFF',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    R_PARKING_ASPH: {
      geometryType: 'polygon',
      symbol: {
        color: '#EAAAFF',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#EAAAFF',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    R_PARKING_CONC: {
      geometryType: 'polygon',
      symbol: {
        color: '#7EBD9D',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#7EBD9D',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    R_PARKING_PAVER: {
      geometryType: 'polygon',
      symbol: {
        color: '#BD9D7E',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#BD9D7E',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    R_PARKING_UNPAVED: {
      geometryType: 'polygon',
      symbol: {
        color: '#7EBD8D',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#7EBD8D',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    R_PAVEMARK_POLY: {
      geometryType: 'polygon',
      symbol: {
        color: '#00FFFF',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#00FFFF',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    R_PAVEMARK_SYMBOL: {
      geometryType: 'polygon',
      symbol: {
        color: '#00FF00',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#00FF00',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    R_ROAD_ASPH: {
      geometryType: 'polygon',
      symbol: {
        color: '#0000FF',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#0000FF',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    R_ROAD_CONC: {
      geometryType: 'polygon',
      symbol: {
        color: '#AABFFF',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#AABFFF',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    R_ROAD_PAVER: {
      geometryType: 'polygon',
      symbol: {
        color: '#7E7EBD',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#7E7EBD',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    R_ROAD_UNPAVED: {
      geometryType: 'polygon',
      symbol: {
        color: '#816000',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#816000',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    R_SHOULDER_PAVED: {
      geometryType: 'polygon',
      symbol: {
        color: '#BD7E9D',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#BD7E9D',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    R_SHOULDER_UNPAVED: {
      geometryType: 'polygon',
      symbol: {
        color: '#FFFFFF',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#FFFFFF',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    R_WALK_ASPH: {
      geometryType: 'polygon',
      symbol: {
        color: '#FFAAFF',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#FFAAFF',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    R_WALK_CONC: {
      geometryType: 'polygon',
      symbol: {
        color: '#814000',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#814000',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    R_WALK_PAVER: {
      geometryType: 'polygon',
      symbol: {
        color: '#685645',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#685645',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    R_WALK_UNPAVED: {
      geometryType: 'polygon',
      symbol: {
        color: '#9DBD7E',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#9DBD7E',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    S_CANAL: {
      geometryType: 'polygon',
      symbol: {
        color: '#7EADBD',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#7EADBD',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    S_DECK: {
      geometryType: 'polygon',
      symbol: {
        color: '#BDBD00',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#BDBD00',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    S_DOCK: {
      geometryType: 'polygon',
      symbol: {
        color: '#00BDBD',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#00BDBD',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    U_GAS_TANK: {
      geometryType: 'polygon',
      symbol: {
        color: '#005EBD',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#005EBD',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    U_SOLAR: {
      geometryType: 'polygon',
      symbol: {
        color: '#45685F',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#45685F',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    U_UTILITY_BOX: {
      geometryType: 'polygon',
      symbol: {
        color: '#00FF00',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#00FF00',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    U_UTILITY_ROOF: {
      geometryType: 'polygon',
      symbol: {
        color: '#6081',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#6081',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    U_UTILITY_STRUCTURE: {
      geometryType: 'polygon',
      symbol: {
        color: '#AAFFBF',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#AAFFBF',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    V_DITCH: {
      geometryType: 'polygon',
      symbol: {
        color: '#7EBD7E',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#7EBD7E',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    V_GRAVEL: {
      geometryType: 'polygon',
      symbol: {
        color: '#8181',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#8181',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    V_RIPRAP: {
      geometryType: 'polygon',
      symbol: {
        color: '#8D7EBD',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#8D7EBD',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    V_ROCKOUTCROP: {
      geometryType: 'polygon',
      symbol: {
        color: '#BDBD7E',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#BDBD7E',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    V_SHRUB: {
      geometryType: 'polygon',
      symbol: {
        color: '#00811F',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#00811F',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    V_ParkLINE: {
      geometryType: 'polygon',
      symbol: {
        color: '#6800',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#6800',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    V_VEGETATION: {
      geometryType: 'polygon',
      symbol: {
        color: '#FFFF00',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#FFFF00',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    W_WATER: {
      geometryType: 'polygon',
      symbol: {
        color: '#00FFFF',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#00FFFF',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    A_BREAKLINE_CONC_EDGE: {
      geometryType: 'polyline',
      symbol: {
        color: '#FFEAAA',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    A_BREAKLINE_CURB_BOTTOM: {
      geometryType: 'polyline',
      symbol: {
        color: '#BD005E',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    A_BREAKLINE_CURB_TOP: {
      geometryType: 'polyline',
      symbol: {
        color: '#BD7E8D',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    A_BREAKLINE_FLOWLINE: {
      geometryType: 'polyline',
      symbol: {
        color: '#BD8D00',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    A_BREAKLINE_GUTTER: {
      geometryType: 'polyline',
      symbol: {
        color: '#8DBD7E',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    A_BREAKLINE_OBSTRUCTION: {
      geometryType: 'polyline',
      symbol: {
        color: '#FF0000',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    A_BREAKLINE_ROAD_CENTER: {
      geometryType: 'polyline',
      symbol: {
        color: '#818100',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    A_BREAKLINE_ROAD_EDGE: {
      geometryType: 'polyline',
      symbol: {
        color: '#003FFF',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    A_BREAKLINE_RW_BOTTOM: {
      geometryType: 'polyline',
      symbol: {
        color: '#AAAAFF',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    A_BREAKLINE_RW_TOP: {
      geometryType: 'polyline',
      symbol: {
        color: '#AAD4FF',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    A_BREAKLINE_WALK_EDGE: {
      geometryType: 'polyline',
      symbol: {
        color: '#D4AAFF',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    A_ROAD_CENTERLINE: {
      geometryType: 'polyline',
      symbol: {
        color: '#FFFFFF',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    B_FOOTPRINT: {
      geometryType: 'polyline',
      symbol: {
        color: '#D4FFAA',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    B_FOOTPRINT_OBSTRUCTED: {
      geometryType: 'polyline',
      symbol: {
        color: '#007FFF',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    D_SPAN_VECTOR: {
      geometryType: 'polyline',
      symbol: {
        color: '#AAEAFF',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    G_TOPO_MAJR: {
      geometryType: 'polyline',
      symbol: {
        color: '#808080',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    G_TOPO_MINR: {
      geometryType: 'polyline',
      symbol: {
        color: '#414141',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    R_PAVEMARK_LINE: {
      geometryType: 'polyline',
      symbol: {
        color: '#FF0000',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    R_RAILROAD: {
      geometryType: 'polyline',
      symbol: {
        color: '#BD008D',
        Fill: 'none',
        style: 'Dash',
        width: 1,
      },
      RendererType: 'Simple',
    },
    S_FENCE: {
      geometryType: 'polyline',
      symbol: {
        color: '#ADBD7E',
        Fill: 'none',
        style: 'Dash',
        width: 1,
      },
      RendererType: 'Simple',
    },
    S_FENCE_GATE: {
      geometryType: 'polyline',
      symbol: {
        color: '#00FFFF',
        Fill: 'none',
        style: 'Dash',
        width: 1,
      },
      RendererType: 'Simple',
    },
    S_GUARDRAIL: {
      geometryType: 'polyline',
      symbol: {
        color: '#FFBFAA',
        Fill: 'none',
        style: 'Dash',
        width: 1,
      },
      RendererType: 'Simple',
    },
    S_RAILING: {
      geometryType: 'polyline',
      symbol: {
        color: '#FFD4AA',
        Fill: 'none',
        style: 'Dash',
        width: 1,
      },
      RendererType: 'Simple',
    },
    S_WALL: {
      geometryType: 'polyline',
      symbol: {
        color: '#BD7EAD',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    S_WALL_CONC: {
      geometryType: 'polyline',
      symbol: {
        color: '#567681',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    S_WALL_STONE: {
      geometryType: 'polyline',
      symbol: {
        color: '#414141',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    T_COMM_DROP: {
      geometryType: 'polyline',
      symbol: {
        color: '#FFAA00',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    T_COMM_WIRE: {
      geometryType: 'polyline',
      symbol: {
        color: '#FFAA00',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    T_GUY_OVERHEAD: {
      geometryType: 'polyline',
      symbol: {
        color: '#55FF00',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    T_GUY_WIRE: {
      geometryType: 'polyline',
      symbol: {
        color: '#55FF00',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    T_POWER_DROP: {
      geometryType: 'polyline',
      symbol: {
        color: '#0000FF',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    T_POWER_WIRE: {
      geometryType: 'polyline',
      symbol: {
        color: '#0000FF',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    U_OVERHEAD_DROP: {
      geometryType: 'polyline',
      symbol: {
        color: '#818156',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    U_OVERHEAD_GUY: {
      geometryType: 'polyline',
      symbol: {
        color: '#564568',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    U_OVERHEAD_WIRE: {
      geometryType: 'polyline',
      symbol: {
        color: '#BD002E',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
  },
};
